export default {
  close: "Fermer",
  dataIterator: {
    noResultsText: "Aucun enregistrement correspondant trouvé",
    loadingText: "Chargement de l'élément..."
  },
  dataTable: {
    itemsPerPageText: "Lignes par page:",
    ariaLabel: {
      sortDescending: ": Tri décroissant. Activer pour supprimer le tri.",
      sortAscending:
        ": Tri croissant. Activer pour trier par ordre décroissant.",
      sortNone: ": Non trié. Activer pour trier par ordre croissant."
    },
    sortBy: "Trier par"
  },
  dataFooter: {
    itemsPerPageText: "Élements par page:",
    itemsPerPageAll: "Tous",
    nextPage: "Page suivante",
    prevPage: "Page précédente",
    firstPage: "Première page",
    lastPage: "Dernière page",
    pageText: "{0}-{1} de {2}"
  },
  datePicker: {
    itemsSelected: "{0} sélectionnés"
  },
  noDataText: "Aucune donnée disponible",
  carousel: {
    prev: "Visuel précédent",
    next: "Visuel suivant",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}"
    }
  },
  calendar: {
    moreEvents: "{0} plus"
  },
  fileInput: {
    counter: "{0} fichiers",
    counterSize: "{0} fichiers ({1} au total)"
  },
  timePicker: {
    am: "AM",
    pm: "PM"
  },
  appName: "FunPay237",
  error_denied: "Non autorisé",
  error_occured: "Erreur survenue",
  error_form: "Le formulaire contient des erreurs",
  success_form: "Donnée Enregistrée",
  transfer_message: "Vous ne pouvez pas sélectionner plus de {0} transferts",
  delete_form: "Donnée Supprimée",
  roles: {
    ROLE_ADMIN: "Administrateur",
    ROLE_CLIENT: "Partenaire",
    ROLE_COMPTA: "Finance",
    ROLE_COMMERCIAL: "Commercial"
  },
  operations: {
    CREDIT: "Crédit",
    DEBIT: "Débit",
    WITHDRAWAL: "Retrait",
    CANCEL: "Annulé"
  },
  periods: {
    day: "Jour",
    week: "Semaine",
    month: "Mois",
    year: "Année"
  },
  operators: {
    eq: "Egal",
    lte: "Inférieur ou égal",
    gte: "Supérieur ou égal"
  },
  transactions: {
    OM: "Orange Money",
    MOMO: "Mtn Mobile Money",
    EUM: "Express Union Money"
  },
  paymentOperations: {
    NEW: "Nouveau paiement",
    INIT: "Paiement initié sur la passerelle distante",
    SENT: "Demande de paiement envoyé",
    COMPLETE: "Paiement terminé",
    APPROVED: "Approuvé"
  },
  operationType: {
    payment: "Paiement",
    user: "Utilisateur",
    provision: "Mouvements",
    profile: "Profil",
    transfer: "Transfert",
    application: "Application"
  },
  paymentStatus: {
    NEW: "Nouveau",
    PENDING: "En Attente",
    ERROR: "Echec",
    CANCEL: "Annulé",
    TIMEOUT: "Expiré",
    SUCCESS: "Reussi"
  },
  transferStatus: {
    NEW: "En Attente",
    PENDING: "En cours",
    ERROR: "Echec",
    CANCEL: "Annulé",
    TIMEOUT: "Expiré",
    SUCCESS: "Reussi",
    REJECTED: "Rjeté"
  },
  transferApprove: {
    yes: "Oui",
    no: "Non"
  },
  transferSource: {
    API: "API"
  },
  menu: {
    dashboard: "Tableau de bord",
    application: "Applications",
    payment: "Paiements",
    provision: "Mouvements",
    profile: "Profil",
    docs: "Documentation",
    user: "Utilisateurs",
    jobs: "Tâches",
    transfer: "Transferts",
    logout: "Déconnexion"
  },
  btn: {
    refresh: "Actualiser",
    reset: "Réinitialiser",
    close: "Fermer",
    cancel: "Annuler",
    confirm: "Confirmer",
    edit: "Mettre à jour",
    save: "Enregistrer",
    compile: "Compiler"
  },
  security: {
    title: "Connexion",
    description: "Connectez-vous à la plateforme",
    cols: {
      username: {
        title: "Nom d'utilisateur"
      },
      password: {
        title: "Mot de passe"
      }
    },
    form: {
      submit: "Connexion",
      bad_credentials: "Username ou mot de passe incorrectes"
    }
  },
  dashboard: {
    title: "Tableau de bord",
    app: "Application",
    status: "Statut paiement",
    filter: {
      title: "Critère de compilation",
      title2: "Cliquez sur la période pour modifier",
      title3: "Du {0} au {1}"
    },
    graphs: {
      no_data: "Aucune donnée disponible",
      graph_1: {
        title: "Nombre de paiements par statut",
        x: "Libelle",
        y: "Nombre"
      },
      graph_2: {
        title: "Montant paiement par application",
        x: "Libelle",
        y: "Nombre"
      },
      graph_3: {
        title: "Paiements",
        x: "Dates",
        y: "Sommes (Fcfa)"
      },
      graph_4: {
        title: "Nombre de transferts par statut",
        x: "Libelle",
        y: "Nombre"
      },
      graph_5: {
        title: "Montant transfert par application",
        x: "Libelle",
        y: "Nombre"
      },
      graph_6: {
        title: "Transferts",
        x: "Dates",
        y: "Sommes (Fcfa)"
      }
    },
    btn: {
      show: "Afficher",
      png: "Télécharger image en png",
      jpeg: "Télécharger image en jpeg",
      excel: {
        title: "Télécharger fichier en xlsx",
        other: "Télécharger les détails en fichier xlsx"
      },
      filter: {
        title: "Filtrer"
      }
    },
    cols: {
      success: {
        title: "Paiements réussis",
        title2: "Nombre de paiements réussis",
        title3: "Transferts réussis",
        title4: "Nombre de transferts réussis"
      },
      cancel: {
        title: "Paiements annulés",
        title2: "Nombre de paiements annulés",
        title3: "Transferts annulés",
        title4: "Nombre de transferts annulés"
      },
      amount: {
        title: "Montant paiments (XAF)",
        title2: "Revenus (XAF)",
        title3: "Montant transferts (XAF)",
        title4: "Transférés (XAF)"
      },
      period: {
        title: "Période du {0} au {1}",
        title2: "Grouper par"
      },
      devise: {
        title: "Fcfa"
      }
    }
  },
  users: {
    title: "Utilisateurs",
    list: {
      title: "Liste des utilisateurs"
    },
    new: {
      title: "Nouvel utilisateur"
    },
    edit: {
      title: "Mise à jours de l'utilisateur"
    },
    operation: {
      title: "Activités de {0}"
    },
    filter: {
      title: "Filtre sur les utilisateurs"
    },
    btn: {
      new: "Nouvel utilisateur",
      apps: {
        new: {
          title: "Nouvelle Application",
          tooltip: "Cliquez pour voir ses applications"
        }
      },
      operation: {
        tooltip: "Cliquez pour voir ses activités"
      },
      provision: {
        new: {
          title: "Nouveau mouvement du compte",
          tooltip: "Cliquez pour effectuer le mouvement"
        }
      },
      edit: {
        title: "Cliquez pour éditer"
      },
      filter: {
        title: "Filtrer"
      },
      view: {
        title: "Cliquez pour voir les détails"
      },
      setting: {
        tooltip: "Cliquez pour éditer les paramètres"
      }
    },
    view: {
      title: "Détails sur l'utilisateur"
    },
    setting: {
      title: "Paramètres"
    },
    cols: {
      action: {
        title: "Actions"
      },
      created: {
        title: "Crée le"
      },
      username: {
        title: "Nom d'utilisateur *",
        title2: "Nom d'utilisateur",
        required: "Nom d'utilisateur requis",
        length: "Le nom d'utilisateur doit contenir {0} à {1} caractères",
        alphaNum: "Seul les caractères alphanumérique sont autorisé",
        isUnique: "Nom d'utilisateur existant!."
      },
      code: {
        title: "Code *",
        title2: "Code",
        required: "Code requis",
        length: "Le code doit contenir {0} à {1} caractères"
      },
      phone: {
        title: "Numéro de téléphone *",
        title2: "Numéro de téléphone",
        required: "Numéro de téléphone requis",
        phone: "Numéro de téléphone ou format incorrect"
      },
      email: {
        title: "Adresse email *",
        title2: "Adresse email",
        required: "Email requis",
        email: "Format invalid"
      },
      address: {
        title: "Adresse *",
        title2: "Adresse",
        required: "Adresse requis",
        maxLength: "Adresse doit contenir au maximum {1} caractères"
      },
      role: {
        title: "Rôle *",
        title2: "Rôle",
        required: "Rôle requis"
      },
      enabled: {
        title: "Statut",
        enable: {
          title: "Cliquer pour activer",
          message: "Êtes vous sure de vouloir activer cet utilisateur ?"
        },
        disable: {
          title: "Cliquer pour désactiver",
          message: "Êtes vous sure de vouloir désactiver cet utilisateur?"
        }
      },
      balance: {
        title: "Solde (XAF)"
      },
      last_login: {
        title: "Dernière connexion"
      },
      fullname: {
        title: "Nom complet *",
        title2: "Nom complet",
        required: "Nom complete requis",
        length: "Nom complet doit contenir {0} à {1} caractères"
      },
      password: {
        title: "Mot de passe",
        required: "Mot de passe requis",
        length: "Mot de passe doit contenir {0} à {1} caractères"
      },
      repeat_password: {
        title: "Repéter le mot de passe",
        sameAs: "Mot de passe saisie non conforme"
      },
      withdrawalPercent: {
        title: "Pourcentage de retrait *",
        title2: "Pourcentage retrait",
        decimal: "Pourcentage de retrait doit être un nombre",
        required: "Pourcentage de retrait requis",
        operator: "Opérateur"
      },
      paymentChargesPercent: {
        title: "Pourcentage de paiement *",
        title2: "Pourcentage paiement",
        decimal: "Pourcentage de paiement doit être un nombre",
        required: "Pourcentage de paiement requis"
      },
      setting: {
        title: "Paramètres",
        transfer: {
          between: "La valeur doit être comprise entre de {0} et {1}",
          amount_max: {
            title: "Transfert maximum",
            integer: "Transfert maximum doit être un entier.",
            required: "Transfert maximum requis",
            max: "Transfert maximum doit être supérieur à {0}"
          },
          amount_min: {
            title: "Transfert minimum *",
            title2: "Transfert minimum",
            integer: "Transfert minimum doit être un entier.",
            required: "Transfert minimum requis",
            min: "Transfert minimum doit être supérieur ou égal à {0}"
          },
          active: {
            title: "Autoriser le transfert"
          },
          daily_withdrawal_limit: {
            title: "Limite Journalière transfère"
          }
        },
        payment: {
          between: "La valeur doit être comprise entre de {0} et {1}",
          amount_max: {
            title: "Paiement maximum",
            integer: "Paiement maximum doit être un entier.",
            required: "Paiement maximum requis",
            max: "Paiement maximum doit être supérieur à {0}"
          },
          amount_min: {
            title: "Paiement minimum *",
            title2: "Paiement minimum",
            integer: "Paiement minimum doit être un entier.",
            required: "Paiement minimum requis",
            min: "La valeur doit être supérieur à {0}"
          }
        }
      }
    }
  },
  application: {
    title: "Applications",
    list: {
      title: "Liste des applications {0}"
    },
    edit: {
      title: "Mise à jours de l'application"
    },
    view: {
      title: "Détails sur l'application"
    },
    filter: {
      title: "Filtre sur les applications"
    },
    btn: {
      new: "Nouvel Application {0}",
      edit: {
        title: "Cliquez pour éditer"
      },
      delete: {
        tooltip: "Cliquez pour supprimer",
        message: "Êtes vous sure de vouloir supprimer l'application ?"
      },
      filter: {
        title: "Filtrer"
      },
      view: {
        title: "Cliquez pour voir les détails"
      },
      payment: {
        tooltip: "Cliquez pour voir les paiements"
      },
      secret: {
        tooltip: "Cliquez pour générer un nouveau secret"
      },
      tester: {
        tooltip: "Cliquez pour éffectuer un paiement ou un transfert",
        menu: {
          payment: "Paiement",
          transfer: "Transfert"
        }
      }
    },
    cols: {
      action: {
        title: "Actions"
      },
      created: {
        title: "Crée le"
      },
      user: {
        title: "Utilisateur",
        required: "Utilisateur requis"
      },
      name: {
        title: "Nom",
        required: "Nom requis",
        isUnique: "Nom existant!.",
        length: "Le nom doit contenir {0} à {1} caractères"
      },
      shortName: {
        title: "Nom court",
        required: "Nom court requis",
        isUnique: "Nom court existant!.",
        length: "Le nom court doit contenir {0} à {1} caractères"
      },
      email: {
        title: "Adresse email",
        email: "Format invalid"
      },
      description: {
        title: "Description"
      },
      notificationActive: {
        title: "Notif sms",
        title2: "Notification sms",
        enable: {
          title: "Cliquer pour activer la notification sms",
          title2: "Activé",
          message: "Êtes vous sure de vouloir activer la notification sms?"
        },
        disable: {
          title: "Cliquer pour désactiver la notification sms",
          title2: "désactivé",
          message: "Êtes vous sure de vouloir désactiver la notification sms?"
        }
      },
      notificationEmailActive: {
        title: "Notif email",
        title2: "Notification email",
        enable: {
          title: "Cliquer pour activer la notification email",
          title2: "Activé",
          message: "Êtes vous sure de vouloir activer la notification email?"
        },
        disable: {
          title: "Cliquer pour désactiver la notification email",
          title2: "désactivé",
          message: "Êtes vous sure de vouloir désactiver la notification email?"
        }
      },
      active: {
        title: "Statut",
        enable: {
          title: "Cliquer pour activer l'application",
          title2: "Activé",
          message: "Êtes vous sure de vouloir activer l'application ?"
        },
        disable: {
          title: "Cliquer pour désactiver l'application",
          title2: "désactivé",
          message: "Êtes vous sure de vouloir désactiver l'application ?"
        }
      },
      owner: {
        title: "Propriétaire"
      },
      apiKey: {
        title: "Clé Api"
      },
      secret: {
        title: "Secret",
        message: "Êtes vous sure de vouloir générer un nouveau secret ?"
      }
    }
  },
  provision: {
    title: "Mouvement",
    list: {
      title: "Liste des mouvements"
    },
    view: {
      title: "Détails sur le mouvement"
    },
    filter: {
      title: "Filtre sur les mouvements"
    },
    btn: {
      filter: {
        title: "Filtrer"
      },
      view: {
        title: "Cliquez pour voir les détails"
      }
    },
    cols: {
      action: {
        title: "Actions"
      },
      created: {
        title: "Crée le",
        start: {
          title: "Date début",
          required: "Date début est requise"
        },
        end: {
          title: "Date fin",
          required: "Date fin est requise",
          isGreatThan: "Date fin doit être plus grand que {0}."
        }
      },
      user: {
        title: "Propriétaire"
      },
      type: {
        title: "Type"
      },
      reference: {
        title: "Réference"
      },
      amount: {
        title: "Montant",
        title2: "Montant (XAF)",
        required: "Solde requis",
        numeric: "Solde doit être un entier positif",
        operator: "Opérateur"
      },
      oldAmount: {
        title: "Ancien montant"
      },
      newAmount: {
        title: "Nouveau montant"
      },
      operation: {
        title: "Opération",
        required: "Opération requis"
      },
      comment: {
        title: "Commentaire"
      },
      charge: {
        title: "Charge"
      }
    }
  },
  payment: {
    title: "Paiements",
    list: {
      title: "Liste des paiements {0}"
    },
    view: {
      title: "Détails sur le paiement"
    },
    changeStatus: {
      title: "Changement de statut du paiement"
    },
    filter: {
      title: "Filtre sur les paiements"
    },
    btn: {
      filter: {
        title: "Filtrer"
      },
      excelFile: {
        title: "Télécharger",
        message: "Vous devez séléctionner une période avant de télécharger"
      },
      view: {
        title: "Cliquez pour voir les détails"
      },
      print: {
        title: "Imprimer le reçu"
      },
      changeStatus: {
        title: "Cliquez pour changer le statut du paiement"
      }
    },
    cols: {
      action: {
        title: "Actions"
      },
      created: {
        title: "Crée le",
        start: {
          title: "Date début",
          required: "Date début est requise"
        },
        end: {
          title: "Date fin",
          required: "Date fin est requise",
          isGreatThan: "Date fin doit être plus grand que {0}."
        }
      },
      expired: {
        title: "Expiré le"
      },
      accountNumber: {
        title: "Numéro de compte"
      },
      amount: {
        title: "Montant",
        title2: "Montant approvisionné",
        operator: "Opérateur",
        required: "Opérateur requis"
      },
      invoiceId: {
        title: "Identifiant de facture"
      },
      reference: {
        title: "Référence"
      },
      remoteReference: {
        title: "Référence distante"
      },
      error: {
        title: "Description de l'erreur"
      },
      data: {
        title: "Données"
      },
      charges: {
        title: "Frais"
      },
      transaction: {
        title: "Type"
      },
      operation: {
        title: "Opération",
        title2: "Opération *",
        required: "Opération requis"
      },
      status: {
        title: "Statut",
        title2: "Statut *",
        required: "Statut requis"
      },
      application: {
        title: "Application"
      },
      identifier: {
        title: "Identifiant"
      },
      remoteIdentifier: {
        title: "Identifiant distant"
      },
      comment: {
        title: "Commentaire",
        required: "Commentaire requis"
      },
      user: {
        title: "Propriétaire"
      }
    }
  },
  profile: {
    title: "Profil",
    list: {
      title: "Informations personnelles"
    },
    password: {
      title: "Changer de mot de passe"
    },
    btn: {
      password: {
        title: "Changer mot de passe"
      }
    },
    cols: {
      username: {
        title: "Nom utilisateur"
      },
      fullName: {
        title: "Nom",
        required: "Nom requis",
        length: "Le code doit contenir {0} à {1} caractères"
      },
      phone: {
        title: "Numéro de téléphone",
        required: "Numéro de téléphone requis",
        phone: "Numéro de téléphone ou format incorrect"
      },
      email: {
        title: "Email",
        required: "Email requis"
      },
      address: {
        title: "Adresse",
        required: "Adresse requis"
      },
      old_password: {
        title: "Mot de passe actuel",
        required: "Mot de passe actuel requis",
        length: "Mot de passe actuel doit contenir {0} à {1} caractères"
      },
      password: {
        title: "Mot de passe",
        required: "Mot de passe requis",
        length: "Mot de passe doit contenir {0} à {1} caractères"
      },
      repeat_password: {
        title: "Repéter le mot de passe",
        sameAs: "Mot de passe saisie non conforme"
      }
    }
  },
  jobs: {
    title: "Tâches",
    list: {
      title: "Liste des tâches"
    },
    edit: {
      title: "Mise à jours de la tâche"
    },
    view: {
      title: "Détails sur la tâche"
    },
    btn: {
      filter: {
        title: "Filtrer"
      },
      edit: {
        title: "Cliquez pour éditer"
      },
      view: {
        title: "Cliquez pour voir les détails"
      }
    },
    cols: {
      action: {
        title: "Actions"
      },
      created: {
        title: "Débuté le"
      },
      name: {
        title: "Nom",
        required: "Nom requis",
        length: "Nom doit contenir {0} à {1} caractères"
      },
      initialize: {
        title: "Initialiser",
        enable: {
          title: "Cliquer pour initialiser",
          message: "Êtes vous sure de vouloir initialiser ?"
        },
        disable: {
          title: "Cliquer pour stopper l'initialisation ",
          message: "Êtes vous sure de vouloir stopper l'initialisation ?"
        }
      },
      started: {
        title: "Démarrée",
        enable: {
          title: "Cliquer pour démarrer ",
          message: "Êtes vous sure de vouloir démarrer ?"
        },
        disable: {
          title: "Cliquer pour stopper",
          message: "Êtes vous sure de vouloir stopper ?"
        }
      },
      autostart: {
        title: "Automatique",
        enable: {
          title: "Cliquer pour activer le démarrage automatique",
          message:
            "Êtes vous sure de vouloir activer le démarrage automatique ?"
        },
        disable: {
          title: "Cliquer pour désactiver le démarrage automatique",
          message:
            "Êtes vous sure de vouloir désactiver le démarrage automatique ?"
        }
      },
      cron: {
        title: "Cron",
        required: "Cron requis",
        isCron: "Cron expression invalide"
      },
      jobClass: {
        title: "Job Class"
      },
      description: {
        title: "Description"
      },
      parameters: {
        title: "Paramètre",
        limit: "limit",
        attempt: "Tentative"
      }
    }
  },
  operation: {
    timeline: {
      no_activity: {
        title: "Activité",
        message: "Aucune activité enregistré pour cet utilisateur"
      },
      no_data: "Aucune Donnée",
      no_more: "Plus de donnée disponible"
    },
    cols: {
      created: {
        title: "le",
        start: {
          title: "Date début",
          required: "Date début est requise"
        },
        end: {
          title: "Date fin",
          required: "Date fin est requise",
          isGreatThan: "Date fin doit être plus grand que {0}."
        }
      },
      user: {
        title: "Effectué par"
      }
    }
  },
  tester: {
    title: "Testeur",
    new: {
      title: "Effectuer un paiement sur {0}",
      title2: "Effectuer un transfert sur {0}",
      title3: "Effectuer un transfert"
    },
    notice: "Résultat du paiement effectué",
    message: {
      success: "Votre paiement a réussi!.",
      error: "Votre paiement a échoué!.",
      cancel: "Votre paiement a été annulé!.",
      timeout: "Votre paiement a expiré!."
    },
    btn: {
      save: {
        title: "Confirmer"
      },
      back: {
        title: "Détails du paiement"
      }
    },
    cols: {
      amount: {
        title: "Montant",
        required: "Montant requis",
        numeric: "Montant doit être un nombre",
        between: "Le montant doit être compris entre {0} et {1} XAF",
        min: "La valeur doit être supérieur à {0}"
      },
      type: {
        title: "Selectionner le mode de paiement",
        title2:
          "Selectionner le mode de paiement avec lequel vous souhaitez effectuer le paiement",
        title3: "Mode de paiement",
        required: "Mode de paiement requis"
      },
      accountNumber: {
        title: "Entrer votre numéro de téléphone pour le paiement",
        required: "Numéro de téléphone requis",
        invalid:
          "Numéro de téléphone invalide. Ne correspond pas au mode de paiement"
      },
      application: {
        title: "Application",
        required: "Application requis"
      },
      transactionId: {
        title: "Numéro de transaction"
      },
      invoiceId: {
        title: "Numéro de facture"
      },
      expiredAt: {
        title: "Date expiration"
      },
      redirectUrl: {
        title: "Url de redirection"
      },
      operation: {
        title: "Opération"
      },
      status: {
        title: "Statut"
      },
      otp: {
        title: "Code de paiement",
        required: "Code de paiement requis",
        invalid: "Format code de paiement invalide",
        message:
          "Obtenez gratuitement votre code de paiement Orange Money au #150*44#"
      }
    }
  },
  transfer: {
    title: "Transferts",
    title2: "Transfert",
    list: {
      title: "Liste des transferts"
    },
    view: {
      title: "Détails sur le transfert"
    },
    info: {
      title: "Information du transfert",
      title2: "Montant à transférer"
    },
    filter: {
      title: "Filtre sur les transferts"
    },
    approve: {
      title: "Approuver les transferts"
    },
    cancel: {
      title: "Annuler les transferts"
    },
    btn: {
      filter: {
        title: "Filtrer"
      },
      excelFile: {
        title: "Télécharger",
        message: "Vous devez séléctionner une période avant de télécharger"
      },
      view: {
        title: "Cliquez pour voir les détails"
      },
      approve: {
        title: "Approuver",
        title2: "Confirmer approbation"
      },
      cancel: {
        title: "Annuler",
        title2: "Confirmer annulation"
      },
      save: {
        title: "Valider la demande"
      },
      transfer: {
        title: "Effectuer transfert"
      },
      action: {
        title: "Effectuer une action sur les transferts"
      }
    },
    cols: {
      action: {
        title: "Actions"
      },
      created: {
        title: "Crée le",
        start: {
          title: "Date début",
          required: "Date début est requise"
        },
        end: {
          title: "Date fin",
          required: "Date fin est requise",
          isGreatThan: "Date fin doit être plus grand que {0}."
        }
      },
      expired: {
        title: "Expiré le"
      },
      accountNumber: {
        title: "Numéro de compte",
        title2: "Téléphone"
      },
      amount: {
        title: "Montant",
        title2: "Montant déduit",
        operator: "Opérateur",
        required: "Opérateur requis"
      },
      invoiceId: {
        title: "Identifiant de facture"
      },
      reference: {
        title: "Référence"
      },
      remoteReference: {
        title: "Référence distante"
      },
      transaction: {
        title: "Type",
        title2: "Type de compte"
      },
      operation: {
        title: "Opération",
        title2: "Opération *",
        required: "Opération requis"
      },
      status: {
        title: "Statut"
      },
      application: {
        title: "Application"
      },
      identifier: {
        title: "Identifiant"
      },
      remoteIdentifier: {
        title: "Identifiant distant"
      },
      error: {
        title: "Description de l'erreur"
      },
      data: {
        title: "Données"
      },
      user: {
        title: "Propriétaire"
      },
      charges: {
        title: "Frais"
      },
      withdrawalAuto: {
        title: "Retrait automatique"
      },
      enterprise: {
        title: "Entreprise"
      },
      service: {
        title: "Service"
      },
      address: {
        title: "Adresse"
      }
    },
    msg: {
      title: "Le montant de transfert doit être compris entre {0} et {1}",
      title2:
        "Le montant demandé ne figure pas dans votre compte. Bien vouloir l'approvisionner"
    }
  },
  exception: {
    pages: {
      403: "Accès refusé. Veuillez contacter l'administrateur s'il vous plaît.",
      404: "Désolé, Page non trouvée"
    },
    btn: {
      back: "Retourner"
    }
  }
};
